import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-admin",
  "use": "icon-ums-admin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-ums-admin\"><path d=\"M512.9216 507.904a216.4736 216.4736 0 1 1 0.1024-432.896 216.4736 216.4736 0 0 1-0.1024 432.9472z m0-371.456a155.0336 155.0336 0 1 0 0.1024 310.0672 155.0336 155.0336 0 0 0-0.1024-310.0672z m-258.048 414.4128H771.072a182.3232 182.3232 0 0 1 182.1184 182.1184v140.6464a67.072 67.072 0 0 1-67.0208 67.0208H139.776a67.072 67.072 0 0 1-67.0208-67.072v-140.5952a182.3232 182.3232 0 0 1 182.1184-182.1184z m-120.6784 322.56a5.5808 5.5808 0 0 0 5.632 5.5808h746.2912a5.5808 5.5808 0 0 0 5.632-5.632v-140.3904a120.832 120.832 0 0 0-120.7296-120.6784H254.976a120.8832 120.8832 0 0 0-120.7296 120.6784v140.4416z\" p-id=\"1474\" /><path d=\"M353.6896 750.08h318.464a30.72 30.72 0 1 1 0 61.44h-318.464a30.72 30.72 0 1 1 0-61.44z\" p-id=\"1475\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-admin.svg
// module id = FR/6
// module chunks = 41